import React from "react";
import Text from "../../styleguide/Text";
import SelectableChecker from "./SelectableItem/SelectableChecker";

function Checkbox({
  name,
  label,
  labelAlign = "right",
  disabled,
  checked,
  onChange,
  textVariant,
  className,
  CustomLabelComponent,
}: {
  name?: string;
  label?: string;
  labelAlign?: "left" | "right";
  disabled?: boolean;
  checked?: boolean;
  onChange?: (isChecked: boolean) => void;
  textVariant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body1" | "body2";
  className?: string;
  CustomLabelComponent?: React.ReactNode;
}) {
  const handleChange = (isChecked: boolean) => {
    onChange && onChange(isChecked);
  };

  const getCustomLabelComponent = () => {
    if (CustomLabelComponent) {
      return CustomLabelComponent;
    }
    return (
      <Text
        component="span"
        className="min-w-0 text-left font-medium leading-5 text-ink"
        variant={textVariant}>
        {label}
      </Text>
    );
  };

  return (
    <label
      htmlFor={name}
      className={`inline-flex min-h-[44px] w-fit max-w-full items-center gap-3 rounded-control border px-4 py-3 transition-colors focus-within:ring-2 focus-within:ring-action/25 focus-within:ring-offset-2 ${
        checked ? "border-action/40 bg-action-subtle" : "border-border bg-surface"
      } ${
        disabled
          ? "cursor-not-allowed opacity-60"
          : "cursor-pointer hover:border-action/40 hover:bg-surface-hover"
      } ${className ?? ""}`}>
      {(label || CustomLabelComponent) &&
        labelAlign === "left" &&
        getCustomLabelComponent()}
      <SelectableChecker
        type="checkbox"
        id={name}
        name={name ?? "checkbox"}
        checked={checked}
        onChange={handleChange}
        isDisabled={disabled}
      />

      {(label || CustomLabelComponent) &&
        labelAlign === "right" &&
        getCustomLabelComponent()}
    </label>
  );
}

export default Checkbox;
